// ABOUTME: Shows an icon indicating whether an item is disabled or active.
// ABOUTME: Used in GL item links to visually distinguish disabled items from active ones.

import { ErrorOutlineOutlinedIcon, PowerSettingsNewOutlinedIcon, Tooltip } from '@ds/coolshop';
import type { DataTableRow } from '@ds/data-table';
import type { Row } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

export function GridCellDisabledIndicator({ row }: { row: Row<DataTableRow> }) {
    const intl = useIntl();

    if (row.original.disabled) {
        return (
            <Tooltip
                title={intl.formatMessage({
                    id: 'disabled-item',
                    defaultMessage: 'Disabled Item',
                })}
            >
                <ErrorOutlineOutlinedIcon color="error" fontSize="small" />
            </Tooltip>
        );
    }

    return (
        <Tooltip
            title={intl.formatMessage({
                id: 'active-item',
                defaultMessage: 'Active Item',
            })}
        >
            <PowerSettingsNewOutlinedIcon color="primary" fontSize="small" />
        </Tooltip>
    );
}
